import './index.css';

import './scss/_style.scss';

import { renderApp } from 'utils/renderApp';
import { loadPolyfills } from 'utils/polyfills';

import * as serviceWorker from 'utils/serviceWorker';
import { renderMetaTags } from 'utils/metaUtils';

loadPolyfills();
renderApp();
renderMetaTags();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
